import { css } from '@emotion/react'
import styles, { mediaQuery, textEllipsis, typo } from '@mathflat/common/style'

const {
  colors: { gray },
} = styles

const S = {
  Wrap: css`
    right: 24px;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    padding-left: 30px;

    ${mediaQuery.large} {
      padding-left: 16px;
    }

    .flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .handler-button {
      min-width: 40px;
      width: 40px;
      height: 100%;
      border-radius: var(--Radius-100);
      &.clicked {
        background-color: var(--Colors-Gray-100);
      }
    }

    .icon__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: var(--Radius-200);
      position: relative;

      &:hover {
        background-color: var(--Colors-Gray-100);
      }

      &.active {
        background-color: var(--Colors-Gray-200);
        svg {
        }
      }
    }

    .button__notification {
      position: relative;
      border-radius: var(--Radius-200);

      .unread-count {
        position: absolute;
        bottom: 16px;
        left: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1px 4px 0px 4px;
        color: white;
        ${typo.caption02}
        font-weight: 700;
        border: 1px solid white;
        border-radius: var(--Radius-Circle);
        background: var(--Colors-Red-500);

        &.max-count {
          padding: 1px 2px 0px 2px;
        }
      }
    }

    .count-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 14px;
      color: var(--White);
      border-radius: var(--Radius-Circle);
      background: var(--Colors-Red-500);
      padding: 1px 4px;
      z-index: 10;
      ${typo.caption02};
      font-weight: 700;
    }

    .noti-badge {
      position: absolute;
      left: 20px;
      top: 5px;
      border: 1px solid var(--White);
    }

    .header__school-exam-zone-badge-container {
      position: relative;
      margin: 8px;
      cursor: pointer;
    }
  `,
  guideButton: css`
    display: inline-flex;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
  `,
  basic: css`
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;

    .header__profile {
      position: relative;
      display: flex;
      align-items: center;
      gap: 4px;
      height: 33px;
      padding: 6px 12px;
      min-width: 87px;
      border-radius: var(--Radius-200);
      border: 1px solid ${gray.$400} !important;
      background-color: var(--White);
      color: ${gray.$700};
      margin-left: 8px;
      overflow: hidden;

      @media (hover: hover) {
        &:hover {
          background-color: var(--Colors-Gray-100);
        }
      }

      &:active {
        background-color: var(--Colors-Gray-200);
        color: var(--Colors-Gray-800);
      }

      &.active {
        ${typo.body02}
        font-weight: 400;
        background: var(--Colors-Sky-50);
        border: 1px solid var(--Colors-Sky-400) !important;
        color: var(--Colors-Sky-400);

        svg path {
          fill: var(--Colors-Sky-400);
        }

        .profile__star-icon path {
          fill: white;
        }

        @media (hover: hover) {
          &:hover {
            background: var(--Colors-Sky-100);
          }
        }
      }
      .profile__star-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 16px;
        height: 16px;

        border-radius: var(--Radius-Circle);
        background-color: var(--Colors-Orange-300);
      }
      .profile__teacher-nickname {
        line-height: normal;
        font-weight: 400;
      }
    }

    span {
      flex: 1;
      ${textEllipsis(1)};
    }
  `,
  tooltipBanner: (bgUrl: string) => css`
    position: relative;
    display: flex;
    width: 280px;
    height: 83px;
    background: url(${bgUrl}) no-repeat top center;
    background-size: cover;

    .apply-button {
      position: absolute;
      left: 12px;
      bottom: 8px;
      width: 145px;
      height: 30px;
    }
    .clock-area {
      position: absolute;
      top: 18px;
      left: 14px;
      width: 136px;
      height: 21px;
    }
  `,
  textClock: css`
    display: flex;
    ${typo.heading04};
    font-weight: 700;

    .clock-item {
      display: flex;
    }
  `,
}

export default S
